import { PaginatedResponse } from './paginated-response';

export class Team {
  id: string;
  description: string;
  name: string;
  organization_id: string;
  team_lead_user_id: string;
  allowed_pricing: boolean;
  allowed_availability: boolean;
  allowed_create_projects: boolean;
  allowed_create_master_boms: boolean;
  allowed_report_view: boolean;
  user_ids: string[];
  // 0 Initiator - 1 Approver - 2 Contractor
  type: number;
}

export class PaginatedTeamDTO extends PaginatedResponse {
  records: Team[];
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/team.ts